import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { projectTypes } from "../../utils/main";

interface DetailsModalInput {
  project: ProjectContextType;
  onClose: () => void;
  onProjectActivity: () => void;
  anchorEl: (EventTarget & HTMLButtonElement) | undefined;
}

export default function DetailsModal({
  project,
  onClose,
  onProjectActivity,
  anchorEl,
}: DetailsModalInput) {
  const [viewState, setViewState] = useState("S01");

  const description = useMemo(() => {
    if (!project || !project.devices) {
      return [];
    }
    return project.devices.map(
      // TODO: Add the model/version to match the format, example: (183123) - device_description
      (device) => `${device.description}`,
    );
  }, [project]);

  function handleClose() {
    setViewState("S00");
    onClose();
  }

  return (
    <div>
      <Popover
        anchorEl={anchorEl}
        open={viewState === "S01"}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Card className="project-details-modal">
          <CardHeader
            className={"title"}
            title={<Typography variant="h5">Project Details</Typography>}
            action={
              <IconButton
                onClick={handleClose}
                sx={{ "&:hover": { bgcolor: "action.hover" } }}
              >
                <CloseIcon />
              </IconButton>
            }
          />
          <Divider flexItem />
          <CardContent className="details-modal-box">
            <div className="details-section">
              <Typography variant="subtitle2" sx={{ color: "text.disabled" }}>
                Project Name
              </Typography>
              <Typography variant="body2">{project.name}</Typography>
            </div>
            <div className="details-section">
              <Typography variant="subtitle2" sx={{ color: "text.disabled" }}>
                Project Description
              </Typography>
              <Typography variant="body2">{project.description}</Typography>
            </div>
            {project && project.type === projectTypes.device && (
              <div className="details-section">
                <Typography variant="subtitle2" sx={{ color: "text.disabled" }}>
                  GMDN Category
                </Typography>
                <Typography variant={"body2"}>
                  {project.deviceGmdn ? project.deviceGmdn.name : ""}
                </Typography>
              </div>
            )}
            {project && project.type === projectTypes.device && (
              <div className="details-section">
                <Typography variant="subtitle2" sx={{ color: "text.disabled" }}>
                  Device Description
                </Typography>
                <Typography variant="body2">
                  {description.join(", ")}
                </Typography>
              </div>
            )}
            <div className="details-section">
              <Typography variant="subtitle2" sx={{ color: "text.disabled" }}>
                Date Range
              </Typography>
              <Typography variant="body2">
                {project.startDate?.toDateString()} -{" "}
                {project.endDate?.toDateString()}
              </Typography>
            </div>
          </CardContent>
          <Divider flexItem />
          <CardActions className="details-bottom-actions">
            <Button size="small" variant="outlined" onClick={onProjectActivity}>
              View Project Activity
            </Button>
          </CardActions>
        </Card>
      </Popover>
    </div>
  );
}
